import React from 'react';
function HierarchicalList({ className = '', classNames = {}, items, createURL, onNavigate = null, }) {
    const listClass = [
        'ais-HierarchicalMenu-list',
        classNames.list,
        className,
    ].filter(Boolean).join(' ');
    return (React.createElement("ul", { className: listClass }, items.map((item) => {
        const itemClass = [
            'ais-HierarchicalMenu-item',
            classNames.item,
            item.data ? 'ais-HierarchicalMenu-item--parent' : '',
            item.data ? classNames.parentItem : '',
            item.isRefined ? 'ais-HierarchicalMenu-item--selected' : '',
            item.isRefined ? classNames.selectedItem : '',
        ].filter(Boolean).join(' ');
        const linkClass = [
            'ais-HierarchicalMenu-link',
            classNames.link,
            item.isRefined ? 'ais-HierarchicalMenu-link--selected' : '',
            item.isRefined ? classNames.selectedItemLink : '',
        ].filter(Boolean).join(' ');
        const labelClass = [
            'ais-HierarchicalMenu-label',
            classNames.label,
        ].filter(Boolean).join(' ');
        const countClass = [
            'ais-HierarchicalMenu-count',
            classNames.count,
        ].filter(Boolean).join(' ');
        const childClass = [
            'ais-HierarchicalMenu-list--child',
            classNames.childList,
        ].filter(Boolean).join(' ');
        return (React.createElement("li", { key: item.value, className: itemClass },
            React.createElement("a", { className: linkClass, href: createURL(item.value), onClick: (event) => {
                    if (!onNavigate) {
                        return;
                    }
                    event.preventDefault();
                    onNavigate(item.value);
                } },
                React.createElement("span", { className: labelClass }, item.label),
                React.createElement("span", { className: countClass }, item.count)),
            (item.data && item.data.length > 0) && (React.createElement(HierarchicalList, { className: childClass, classNames: classNames, items: item.data, createURL: createURL, onNavigate: onNavigate }))));
    })));
}
export default function HierarchicalMenu({ menu, menuSettings, createURL: customCreateURL, }) {
    const id = encodeURIComponent(`white-instant-search-hierarchical-menu--${menuSettings.attributes.join('')}`)
        .toLowerCase()
        .replace(/\.|%[0-9a-z]{2}/gi, '');
    const { classNames, showMore, translations, hardRefresh, } = menuSettings;
    const { items, isShowingMore, canToggleShowMore, toggleShowMore, createURL, refine, } = menu;
    const rootClass = [
        'ais-HierarchicalMenu',
        classNames === null || classNames === void 0 ? void 0 : classNames.root,
        items.length === 0 ? 'ais-HierarchicalMenu--noRefinement' : '',
        items.length === 0 ? classNames === null || classNames === void 0 ? void 0 : classNames.noRefinementRoot : '',
    ].filter(Boolean).join(' ');
    const showMoreClass = [
        'ais-HierarchicalMenu-showMore',
        classNames === null || classNames === void 0 ? void 0 : classNames.showMore,
        !canToggleShowMore ? 'ais-HierarchicalMenu-showMore--disabled' : '',
        !canToggleShowMore ? classNames === null || classNames === void 0 ? void 0 : classNames.disabledShowMore : '',
    ].filter(Boolean).join(' ');
    return (React.createElement("div", { id: id, className: rootClass },
        React.createElement(HierarchicalList, { classNames: classNames, items: items, createURL: customCreateURL || createURL, onNavigate: hardRefresh ? null : refine }),
        showMore && (React.createElement("button", { className: showMoreClass, disabled: !canToggleShowMore, type: "button", onClick: toggleShowMore }, (translations === null || translations === void 0 ? void 0 : translations.showMoreButtonText)
            ? translations.showMoreButtonText({ isShowingMore })
            : ''))));
}
